var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.5C12.2929 19.5 12.125 19.3321 12.125 19.125C12.125 18.9179 12.2929 18.75 12.5 18.75",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.5C12.7071 19.5 12.875 19.3321 12.875 19.125C12.875 18.9179 12.7071 18.75 12.5 18.75",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.75V8.25",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.121 1.76001C13.9722 1.45702 13.7414 1.20181 13.4549 1.02333C13.1684 0.844851 12.8376 0.750244 12.5 0.750244C12.1624 0.750244 11.8316 0.844851 11.5451 1.02333C11.2586 1.20181 11.0278 1.45702 10.879 1.76001L1.40601 21.058C1.29198 21.29 1.23895 21.5472 1.25192 21.8053C1.26489 22.0635 1.34343 22.3141 1.48014 22.5334C1.61684 22.7528 1.8072 22.9337 2.03324 23.0591C2.25927 23.1845 2.51353 23.2502 2.77201 23.25H22.228C22.4865 23.2502 22.7407 23.1845 22.9668 23.0591C23.1928 22.9337 23.3832 22.7528 23.5199 22.5334C23.6566 22.3141 23.7351 22.0635 23.7481 21.8053C23.7611 21.5472 23.708 21.29 23.594 21.058L14.121 1.76001Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAlertTriangle;